import { render, staticRenderFns } from "./ClientStatistics.vue?vue&type=template&id=37535c8e&scoped=true&"
import script from "./ClientStatistics.vue?vue&type=script&lang=js&"
export * from "./ClientStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ClientStatistics.vue?vue&type=style&index=0&id=37535c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37535c8e",
  null
  
)

export default component.exports